var map = {
	"./avatar-name-bg.png": "2420",
	"./avatar-terminator.png": "3060",
	"./avatar_descr_border.png": "772a",
	"./circle-stage-green.png": "4408",
	"./circle-stage.png": "9793",
	"./cloud.png": "845b",
	"./coins-placeholder.png": "e7ad",
	"./congratulations-box-bg.png": "6670",
	"./custom-cursor.png": "9b31",
	"./end-dash.png": "9572",
	"./font-size_dropdown.png": "3cfa",
	"./fontsize-button-mobile.png": "fdab",
	"./fontsize-button.png": "d2e3",
	"./headphones-box-bg.png": "1a35",
	"./headphones.png": "8f44",
	"./help-button.png": "2abb",
	"./info-button-dropdown.png": "30df",
	"./info-button.png": "aed2",
	"./journal-button.png": "1259",
	"./journal/Antoinette-full.png": "1938",
	"./journal/Antoinette.png": "4863",
	"./journal/Barakov-full.png": "f6a8",
	"./journal/Barakov.png": "d566",
	"./journal/Kraven-full.png": "71f2",
	"./journal/Kraven.png": "46eb",
	"./journal/Tyara-full.png": "2a1e",
	"./journal/Tyara.png": "a669",
	"./journal/Willem-full.png": "a046",
	"./journal/Willem.png": "1ef9",
	"./journal/buttons/artifacts.png": "a234",
	"./journal/buttons/book.png": "5858",
	"./journal/buttons/close.png": "9c5a",
	"./journal/buttons/map.png": "ccd2",
	"./journal/buttons/npc.png": "27a0",
	"./journal/journal-frame-bg.png": "d251",
	"./journal/journal-page-top.png": "6ba1",
	"./journal/ornament.png": "b063",
	"./lang-select-bg.png": "42f7",
	"./lang-select-bg2.png": "4c95",
	"./localization/br/continue-button.png": "abde",
	"./localization/br/drag-to-answer-white.png": "8330",
	"./localization/br/play-button.png": "7f69",
	"./localization/br/replay-button.png": "3a08",
	"./localization/br/skip-button.png": "f47c",
	"./localization/br/submit-button.png": "9adc",
	"./localization/de/continue-button.png": "51e5",
	"./localization/de/drag-to-answer-white.png": "0c04",
	"./localization/de/play-button.png": "0ac9",
	"./localization/de/replay-button.png": "f174",
	"./localization/de/skip-button.png": "c54a",
	"./localization/de/submit-button.png": "118c",
	"./localization/el/continue-button.png": "355e",
	"./localization/el/drag-to-answer-white.png": "e445",
	"./localization/el/play-button.png": "a7f1",
	"./localization/el/replay-button.png": "417a",
	"./localization/el/skip-button.png": "cda8",
	"./localization/el/submit-button.png": "f2a6",
	"./localization/en/continue-button.png": "ba11",
	"./localization/en/drag-to-answer-white.png": "8aac",
	"./localization/en/play-button.png": "7211",
	"./localization/en/replay-button.png": "bdac",
	"./localization/en/skip-button-old.png": "9471",
	"./localization/en/skip-button.png": "1e56",
	"./localization/en/submit-button.png": "fdaa",
	"./localization/es/continue-button.png": "e9b4",
	"./localization/es/drag-to-answer-white.png": "a806",
	"./localization/es/play-button.png": "fed3",
	"./localization/es/replay-button.png": "b620",
	"./localization/es/skip-button.png": "8cbc",
	"./localization/es/submit-button.png": "87ff",
	"./localization/it/continue-button.png": "15fa",
	"./localization/it/drag-to-answer-white.png": "c05c",
	"./localization/it/play-button.png": "464f",
	"./localization/it/replay-button.png": "2cd1",
	"./localization/it/skip-button.png": "0355",
	"./localization/it/submit-button.png": "7255",
	"./localization/ko/continue-button-old.png": "8fb5",
	"./localization/ko/continue-button.png": "6252",
	"./localization/ko/drag-to-answer-white.png": "2c25",
	"./localization/ko/play-button.png": "e3ce",
	"./localization/ko/replay-button-old.png": "91be",
	"./localization/ko/replay-button.png": "b207",
	"./localization/ko/skip-button-old.png": "3b40",
	"./localization/ko/skip-button.png": "50f5",
	"./localization/ko/submit-button-old.png": "38a6",
	"./localization/ko/submit-button.png": "5e50",
	"./localization/ru/continue-button.png": "67d5",
	"./localization/ru/drag-to-answer-white.png": "2214",
	"./localization/ru/play-button.png": "0ea4",
	"./localization/ru/replay-button.png": "52c0",
	"./localization/ru/skip-button.png": "d3c5",
	"./localization/ru/submit-button.png": "1475",
	"./localization/sl/continue-button.png": "1081",
	"./localization/sl/drag-to-answer-white.png": "7739",
	"./localization/sl/play-button.png": "113d",
	"./localization/sl/replay-button.png": "1d09",
	"./localization/sl/skip-button.png": "3541",
	"./localization/sl/submit-button.png": "053b",
	"./localization/tr/continue-button.png": "6a95",
	"./localization/tr/drag-to-answer-white.png": "dd4e",
	"./localization/tr/play-button.png": "9fafa",
	"./localization/tr/replay-button.png": "6174",
	"./localization/tr/skip-button.png": "84d7",
	"./localization/tr/submit-button.png": "f5ae",
	"./localization/us/continue-button.png": "cb7f",
	"./localization/us/drag-to-answer-white.png": "b144",
	"./localization/us/play-button.png": "7d7e",
	"./localization/us/replay-button.png": "29c0",
	"./localization/us/skip-button.png": "c428",
	"./localization/us/submit-button.png": "4b6c",
	"./login-button.png": "3392",
	"./login-input-bg.png": "a593",
	"./login-overlay-bg.png": "6f7d",
	"./logo.png": "4ffd",
	"./mCSB_buttons.png": "fcc4",
	"./mid-dash.png": "4885",
	"./mobile-cloud.png": "7c2b",
	"./mute-button.png": "0e42",
	"./piece.png": "eb67",
	"./player-name-bg-v2.png": "da55",
	"./progress-bar-v2.png": "7be9",
	"./progress-bar.png": "4e59",
	"./progress/islands/Alchimeia.png": "3776",
	"./progress/islands/Alchimeia_closed.png": "134c",
	"./progress/islands/Fabella.png": "06a3",
	"./progress/islands/Fabella_closed.png": "050c",
	"./progress/islands/Lumina.png": "9f7c",
	"./progress/islands/Lumina_closed.png": "2dbd",
	"./progress/islands/Morbida.png": "9cb1",
	"./progress/islands/Morbida_closed.png": "a114",
	"./progress/islands/Oracle.png": "8b09",
	"./progress/islands/Oracle_closed.png": "71ed",
	"./progress/islands/Sylva.png": "7b8b",
	"./progress/islands/Sylva_closed.png": "435d",
	"./progress/islands/Temperus.png": "f828",
	"./progress/islands/Temperus_closed.png": "58e2",
	"./progress/islands/Veritas.png": "9dce",
	"./progress/islands/Veritas_closed.png": "68bc",
	"./progress/islands/Void.png": "1705",
	"./progress/islands/chance.png": "a6ac",
	"./progress/islands/chance_closed.png": "99a8",
	"./progress/islands/judgement.png": "819b",
	"./progress/islands/judgement_closed.png": "4098",
	"./progress/islands/solace.png": "3d98",
	"./progress/islands/solace_closed.png": "1451",
	"./question-after-bg.png": "d2ee",
	"./question-bg-mobile.png": "92c3",
	"./question-bg-v2.png": "7b8c",
	"./radio-bg.png": "93e9",
	"./reject-coin.png": "69f9",
	"./reply-bg-mobile.png": "6a8c",
	"./reply-bg.png": "a099",
	"./rotate-phone-to-portrait-white.png": "7db5",
	"./rotate-tablet-to-landscape-white.png": "c321",
	"./scroll-bar-gem.png": "51eb",
	"./scroll-bar.png": "b768",
	"./select-coin.png": "af99",
	"./select-lang-btn.png": "6d6a",
	"./select-lang-header.png": "97d9",
	"./sound-button.png": "6584",
	"./view-bg-button.png": "2a82",
	"./world_map/artifacts/Alchimeia.png": "5fa1",
	"./world_map/artifacts/Fabella.png": "3115",
	"./world_map/artifacts/Lumina.png": "f6b45",
	"./world_map/artifacts/Morbida.png": "2d35",
	"./world_map/artifacts/Oracle.png": "310b",
	"./world_map/artifacts/Sylva.png": "9934",
	"./world_map/artifacts/Temperus.png": "f80a",
	"./world_map/artifacts/Veritas.png": "0ba4",
	"./world_map/islands/raw/Alchimeia_island_raw.png": "d5aa",
	"./world_map/islands/raw/Alchimeia_round.png": "698c",
	"./world_map/islands/raw/Chance_island_raw.png": "9dfe",
	"./world_map/islands/raw/Chance_round.png": "458c",
	"./world_map/islands/raw/Fabella_island_raw.png": "3c77",
	"./world_map/islands/raw/Fabella_round.png": "8982",
	"./world_map/islands/raw/Judgement_island_raw.png": "8367",
	"./world_map/islands/raw/Judgement_round.png": "00d9",
	"./world_map/islands/raw/Lumina_island_raw.png": "7f29",
	"./world_map/islands/raw/Lumina_round.png": "8eb4",
	"./world_map/islands/raw/Morbida_island_raw.png": "0ae5",
	"./world_map/islands/raw/Morbida_round.png": "c49d",
	"./world_map/islands/raw/Oracle_island_raw.png": "d8ab",
	"./world_map/islands/raw/Oracle_round.png": "154d",
	"./world_map/islands/raw/Solace_island_raw.png": "c256",
	"./world_map/islands/raw/Solace_round.png": "c53e",
	"./world_map/islands/raw/Sylva_island_raw.png": "22bf",
	"./world_map/islands/raw/Sylva_round.png": "b0b2",
	"./world_map/islands/raw/Temperus_island_raw.png": "4442",
	"./world_map/islands/raw/Temperus_round.png": "3f21",
	"./world_map/islands/raw/Veritas_island_raw.png": "3ac8",
	"./world_map/islands/raw/Veritas_round.png": "7262",
	"./world_map/islands/with_label/Alchimeia_island.png": "02ec",
	"./world_map/islands/with_label/Fabella_island.png": "804d",
	"./world_map/islands/with_label/Lumina_island.png": "68dd",
	"./world_map/islands/with_label/Morbida_island.png": "2694",
	"./world_map/islands/with_label/Oracle_island.png": "b702",
	"./world_map/islands/with_label/Sylva_island.png": "bad7",
	"./world_map/islands/with_label/Temperus_island.png": "7951",
	"./world_map/islands/with_label/Veritas_island.png": "9818",
	"./world_map/islands/with_treasure/Alchimeia_island_treasure.png": "9b10",
	"./world_map/islands/with_treasure/Chance_island_treasure.png": "a72d",
	"./world_map/islands/with_treasure/Fabella_island_treasure.png": "5937",
	"./world_map/islands/with_treasure/Judgement_island_treasure.png": "5919",
	"./world_map/islands/with_treasure/Lumina_island_treasure.png": "5113",
	"./world_map/islands/with_treasure/Morbida_island_treasure.png": "58f0",
	"./world_map/islands/with_treasure/Oracle_island_treasure.png": "1d1f",
	"./world_map/islands/with_treasure/Solace_island_treasure.png": "3416",
	"./world_map/islands/with_treasure/Sylva_island_treasure.png": "c2de",
	"./world_map/islands/with_treasure/Temperus_island_treasure.png": "d574",
	"./world_map/islands/with_treasure/Veritas_island_treasure.png": "1769"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";